import { DEBUG, DEFAULT_PREFS } from "./config";
import { getAppCardNode } from "./appCardDefault";
import { DomHelper } from "./domHelper";
import { Util } from "./util";
import { getBackendData, sendBackendData } from "./xhrbackend";
const LDAP_BASE_DN_GROUP_APP = "ou=ui,ou=groups,dc=open-diakonie,dc=de";
export function appDeskRagAdmin(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appDeskRagAdmin");
    const additionalClassList = [];
    const idString = 'rudi-admin-app';
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    let content = "";
    const userPreferences = userResponse.odDeskPreferences;
    const cardNode = getAppCardNode(parentNode, app, username, userPreferences, bearerToken, false, additionalClassList, null, event => {
        const appGroupNode = document.getElementById('appGroups');
        if (appGroupNode)
            appGroupNode.classList.add('disabled');
        const fullScreenNode = document.getElementById('appFullscreen');
        if (fullScreenNode) {
            const appConfig = JSON.parse(app.odAppConfig);
            fullScreenNode.classList.remove('disabled');
            const headerNode = DomHelper.appendNode(fullScreenNode, 'header', []);
            DomHelper.appendNode(headerNode, 'h1', [], [], appConfig.title ? appConfig.title : "RuDi#Ki Themen Administration");
            const btnNode = DomHelper.appendNode(headerNode, 'div', ['od-button-area']);
            DomHelper.createButtonClose(btnNode, username, bearerToken, userPreferences);
            createButtonRefresh(btnNode, username, bearerToken, userPreferences);
            const adminPane = DomHelper.appendNode(fullScreenNode, 'section', ['odAdminPane']);
            const navNode = DomHelper.appendNode(adminPane, 'section', [], [], "", "odAdminNav");
            const listNode = DomHelper.appendNode(adminPane, 'section', [], [], "", "odAdminList");
            getBackendData("", "/rag/topics", "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                appPartListRender(listNode, username, bearerToken, userPreferences, responseData);
            });
        }
    });
    let injectNodes = cardNode.getElementsByClassName('rudi-app-inject');
    const injectNode = injectNodes.item(0);
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", idString);
        injectNode.innerHTML = content;
        createButtonOpenAppList(injectNode, username, bearerToken, userResponse.odDeskPreferences, app, idString);
    }
    else {
        console.log("Couldn't get Element to add content");
    }
}
function createButtonOpenAppList(injectNode, username, bearerToken, userPreferences, app, idString) {
    const buttonNode = DomHelper.getFirstParentWithClass(injectNode, 'rudi-app');
    buttonNode.addEventListener('click', function (event) {
    });
}
function createButtonRefresh(injectNode, username, bearerToken, userPreferences) {
    const buttonNode = DomHelper.appendNode(injectNode, 'button', ['btn', 'btn-primary', 'mt-2', 'ms-1',], [{
            attr: 'id',
            value: ''
        }]);
    DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-refresh', 'me-1'], []);
    DomHelper.appendNode(buttonNode, 'span', [], [], 'aktualisieren');
    buttonNode.addEventListener('click', function (event) {
        const listNode = document.getElementById("odAdminList");
        if (listNode) {
            listNode.innerHTML = "";
            getBackendData("", "/admin/desk/app", "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                appPartListRender(listNode, username, bearerToken, userPreferences, responseData);
            });
        }
    });
}
function enableInvalidMessage(parentElement, name, message) {
    const invalidNode = parentElement.querySelector(`#${name}-invalid`);
    if (invalidNode) {
        invalidNode.classList.remove('disabled');
        invalidNode.innerText = message;
    }
    const inputNode = parentElement.querySelector(`#app_create-${name.toLowerCase()}`);
    if (inputNode) {
        inputNode.classList.add('invalid');
    }
}
function disableInvalidMessage(parentElement, name) {
    const invalidNode = parentElement.querySelector(`#${name}-invalid`);
    if (invalidNode) {
        invalidNode.classList.add('disabled');
        invalidNode.innerText = "";
    }
    const inputNode = parentElement.querySelector(`app_create-${name.toLowerCase()}`);
    if (inputNode) {
        inputNode.classList.remove('invalid');
    }
}
function validateFormData(topic, parentElement, withCN = false) {
    let formValid = true;
    let valueName = topic.name;
    if (typeof valueName === 'string' && valueName.length > 3) {
        disableInvalidMessage(parentElement, 'description');
    }
    else {
        formValid = false;
        enableInvalidMessage(parentElement, 'name', "Der Name darf nicht leer sein");
    }
    return formValid;
}
function handleAppCreate(username, bearerToken, event, parentDN, appListAll, groupNode) {
    const modalNode = document.getElementById('rudi-modal');
    const modalContentNode = document.getElementById('rudi-modal-content');
    const appItem = {
        id: "new",
        name: "",
        description: "",
        created_at: new Date().toISOString()
    };
    if (modalNode && modalContentNode) {
        DomHelper.showModal(modalNode);
        const titleNode = document.getElementById('rudi-modal-title');
        if (titleNode)
            titleNode.innerHTML = "Neues Thema anlegen";
        const formNode = document.getElementById('rudi-modal-form');
        if (formNode) {
            formNode.innerHTML = "";
            const section = createAppForm(bearerToken, formNode, appItem, modalNode, false, appListAll);
            const buttonSafeNode = DomHelper.appendNode(section, "button", ['btn', 'btn-secondary'], [], '');
            DomHelper.appendNode(buttonSafeNode, 'i', ['fa-light', 'fa-cloud-arrow-up']);
            DomHelper.appendNode(buttonSafeNode, 'span', [], [], 'Speichern');
            buttonSafeNode.addEventListener('click', function (event) {
                event.preventDefault();
                const formData = new FormData(formNode);
                let newApp = {
                    id: "new",
                    name: formData.get('name') ? formData.get('name') : '',
                    description: formData.get('description') ? formData.get('description') : ''
                };
                let formValid = validateFormData(newApp, formNode, true);
                if (!formValid) {
                    return;
                }
                sendBackendData('', `/rag/topics`, 'POST', 'application/json', bearerToken, newApp, function (response) {
                    modalNode.style.display = 'none';
                    const result = JSON.parse(response.target.response);
                    newApp.id = result.id;
                    renderTopicRow(groupNode, newApp, [], bearerToken, username, true);
                });
            });
            const buttonCancelNode = DomHelper.appendNode(section, "button", ['btn', 'btn-secondary'], [], '');
            DomHelper.appendNode(buttonCancelNode, 'i', ['fa-light', 'fa-ban']);
            DomHelper.appendNode(buttonCancelNode, 'span', [], [], 'Abbrechen');
            buttonCancelNode.addEventListener('click', function (event) {
                event.preventDefault();
                modalNode.style.display = 'none';
            });
        }
    }
}
function createAppForm(bearerToken, formNode, appItem, modalNode, shortnameReadonly = true, appListAll) {
    const formName = 'app_create';
    DomHelper.appendInputText(formNode, formName, [], [], 'name', 'Name', appItem.name);
    DomHelper.appendInputText(formNode, formName, [], [], 'description', 'BOM Name', appItem.description);
    const section = DomHelper.appendNode(formNode, 'section', ['rudi-form-input-group'], []);
    return section;
}
function getSortedTopicList(appList) {
    return appList.sort((a, b) => {
        if (typeof a.name == 'undefined' || typeof b.name == 'undefined')
            return 0;
        if (Number(a.name) < Number(b.name))
            return -1;
        if (Number(a.name) > Number(b.name))
            return 1;
        return 0;
    });
}
function renderTableHeader(parentElement) {
    const tableRowNode = DomHelper.appendNode(parentElement, 'tr', [], [], '');
    DomHelper.appendNode(tableRowNode, 'th', [], [], 'Aktionen');
    DomHelper.appendNode(tableRowNode, 'th', [], [], 'Thema');
    DomHelper.appendNode(tableRowNode, 'th', [], [], 'Erstellt am');
}
function appPartListRender(parentElement, username, bearerToken, userPreferences, topicList) {
    captureSearchBar(topicList);
    const sortedTopicList = getSortedTopicList(topicList);
    const tableNode = DomHelper.appendNode(parentElement, 'table', [], []);
    const tableHeadNode = DomHelper.appendNode(tableNode, 'thead', [], []);
    const tableBodyNode = DomHelper.appendNode(tableNode, 'tbody', [], []);
    renderTableHeader(tableHeadNode);
    for (const topic of sortedTopicList) {
        renderTopicRow(tableBodyNode, topic, [], bearerToken, username);
    }
}
function enterEditMode(tableRowNode, app, bearerToken) {
    tableRowNode.classList.add('rudi-app-edit-mode');
    const appEditIconNode = tableRowNode.querySelector('.fa-edit');
    if (appEditIconNode) {
        appEditIconNode.classList.remove('fa-edit');
        appEditIconNode.classList.add('fa-save');
    }
    const appEditTTNode = tableRowNode.querySelector('.tt-btn-edit');
    if (appEditTTNode)
        appEditTTNode.innerText = "Speichern";
    const editableFields = tableRowNode.querySelectorAll('[odEditable="true"]');
    for (const field of editableFields) {
        field.classList.remove('disabled');
        field.setAttribute('contenteditable', 'true');
    }
}
function discardChanges(tableRowNode, app, bearerToken, username) {
    const appEditIconNode = tableRowNode.querySelector('.fa-save');
    const editableFields = tableRowNode.querySelectorAll('[odEditable="true"]');
    for (const field of editableFields) {
        field.setAttribute('contenteditable', 'false');
        if (field.getAttribute('odOnlyShowInEditMode') === 'true') {
            field.classList.add('disabled');
        }
    }
    tableRowNode.classList.remove('rudi-app-edit-mode');
    if (appEditIconNode) {
        appEditIconNode.classList.remove('fa-spin');
        appEditIconNode.classList.remove('fa-spinner-scale');
        appEditIconNode.classList.add('fa-edit');
        appEditIconNode.classList.remove('fa-save');
    }
    const appEditTTNode = tableRowNode.querySelector('.tt-btn-edit');
    if (appEditTTNode)
        appEditTTNode.innerText = "Bearbeiten";
}
function saveChanges(tableRowNode, app, bearerToken, username) {
    const appEditIconNode = tableRowNode.querySelector('.fa-save');
    const editableFields = tableRowNode.querySelectorAll('[odEditable="true"]');
    for (const field of editableFields) {
        const identifier = field.getAttribute("odName");
        if (identifier) {
            app[identifier] = field.innerText;
        }
    }
    if (!validateFormData(app, tableRowNode))
        throw "Validation failed";
    for (const field of editableFields) {
        field.setAttribute('contenteditable', 'false');
        if (field.getAttribute('odOnlyShowInEditMode') === 'true') {
            field.classList.add('disabled');
        }
    }
    if (appEditIconNode) {
        appEditIconNode.classList.add('fa-spin');
        appEditIconNode.classList.add('fa-spinner-scale');
        appEditIconNode.classList.remove('fa-save');
    }
    const appEditTTNode = tableRowNode.querySelector('.tt-btn-edit');
    if (appEditTTNode)
        appEditTTNode.innerText = "Bearbeiten";
    tableRowNode.classList.remove('rudi-app-edit-mode');
    sendBackendData('', `/rag/topicx/${app.id}`, 'PUT', 'application/json', bearerToken, app, function (response) {
        if (appEditIconNode) {
            appEditIconNode.classList.remove('fa-spin');
            appEditIconNode.classList.remove('fa-spinner-scale');
            appEditIconNode.classList.add('fa-edit');
        }
    });
}
function renderTopicRow(parentElement, topic, cssClassList, bearerToken, username, asSibling = false) {
    let tableRowNode;
    if (asSibling) {
        tableRowNode = DomHelper.appendNodeAsSibling(parentElement, 'tr', [...cssClassList], [], '', topic.id);
    }
    else {
        tableRowNode = DomHelper.appendNode(parentElement, 'tr', [...cssClassList], [], '', topic.id);
    }
    const tdNodeEditIconTD = DomHelper.appendNode(tableRowNode, 'td', ['od-edit-icon-area'], []);
    const tdNodeEditIconDiv = DomHelper.appendNode(tdNodeEditIconTD, 'div', ['od-edit-column'], []);
    const tdNodeEditIcon = DomHelper.appendNode(tdNodeEditIconDiv, 'i', ['fa-light', 'fa-edit'], []);
    DomHelper.addToolTip(tdNodeEditIcon, 'Bearbeiten', 'tt-btn-edit');
    let isEditMode = false;
    tdNodeEditIcon.addEventListener('click', function (event) {
        if (isEditMode) {
            try {
                saveChanges(tableRowNode, topic, bearerToken, username);
                tdNodeCancelIconDiv.classList.add('disabled');
                isEditMode = false;
            }
            catch (e) {
                if (DEBUG)
                    console.error("Validation failed");
            }
        }
        else {
            enterEditMode(tableRowNode, topic, bearerToken);
            tdNodeCancelIconDiv.classList.remove('disabled');
            isEditMode = true;
        }
    });
    const tdNodeCancelIconDiv = DomHelper.appendNode(tdNodeEditIconTD, 'div', ['od-edit-column', 'disabled'], []);
    const tdNodeCancelIcon = DomHelper.appendNode(tdNodeCancelIconDiv, 'i', ['fa-light', 'fa-cancel'], []);
    DomHelper.addToolTip(tdNodeCancelIcon, 'Abbrechen');
    tdNodeCancelIcon.addEventListener('click', function (event) {
        if (isEditMode) {
            discardChanges(tableRowNode, topic, bearerToken, username);
            tdNodeCancelIconDiv.classList.add('disabled');
            isEditMode = false;
        }
    });
    const tdTitle = DomHelper.appendNode(tableRowNode, 'td', [], []);
    const aNode = DomHelper.appendNode(tdTitle, 'a', [], [], '', topic.id);
    DomHelper.appendEditableDivNode(aNode, ['rudi-app-title'], [], 'odAppTitle', Util.formatTitleByString(topic.name));
    DomHelper.appendEditableDivNode(aNode, ['od-bom-name'], [], 'description', topic.description ? topic.description : "");
    const tdNodeIconTd = DomHelper.appendNode(tableRowNode, 'td', [], []);
    const tdNodeIconSection = DomHelper.appendNode(tdNodeIconTd, 'section', ['rudi-app-icon'], []);
    return tableRowNode;
}
function captureSearchBar(topics) {
    const searchBarWrapperNode = document.querySelector('section.top-search-bar-wrapper');
    if (searchBarWrapperNode) {
        const oldsearchBar = searchBarWrapperNode.querySelector('.top-search-bar');
        if (oldsearchBar.classList.contains('disabled'))
            return;
        if (oldsearchBar) {
            oldsearchBar.classList.add('disabled');
        }
        const inputNode = DomHelper.appendNode(searchBarWrapperNode, 'div', ['top-search-bar'], [{ attr: 'contenteditable', value: 'true' }, { attr: 'searchbase', value: 'apps' }]);
        inputNode.addEventListener('input', (event) => {
            const searchTerm = event.target.innerText.trim().toLowerCase();
            let filteredApps = [];
            let filter = topics.filter(app => {
                var _a;
                return app.name.toLowerCase().includes(searchTerm) ||
                    ((_a = app.description) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchTerm.toLowerCase()));
            });
            filteredApps.push(...filter);
            const activeNodes = document.querySelectorAll('tbody tr');
            for (const app of activeNodes) {
                if (filteredApps.some(appInfo => appInfo.id === app.getAttribute('id'))) {
                    app.classList.remove('disabled');
                }
                else {
                    app.classList.add('disabled');
                }
            }
        });
    }
}
